import { TransactionStoreService } from "../transaction/transaction.store.service";
import { StoreSubscriber } from "../dependency.subscriber.abstraction";
import { inject } from "@angular/core";
import { TransactionView } from "@bitwarden/web-vault/app/models/view/transaction/transaction.view";
import { filter, skip } from "rxjs";

export class TransactionSubscriber extends StoreSubscriber<TransactionView> {
  /** **<span style="color: red;">This is for store use only</span>** **/
  protected dependentStore: TransactionStoreService = inject(TransactionStoreService);

  /** **<span style="color: red;">This is for store use only</span>** **/
  getObservable() {
    return this.dependentStore.alignedTransactionGeneratedCollection.collection$.pipe(
      skip(1), // todo @alex need to clean up the sync of the store so that is not required anymore
      // Drops the null clearStore() leaves until the next user's first load.
      filter((x) => x != null),
    );
  }

  /** **<span style="color: red;">This is for store use only</span>** **/
  getCollection(): TransactionView[] {
    // null between TransactionStoreService.clearStore() and the next user's first load; a stale
    // refreshState() continuation can still land here (see monthly-summary.service.ts).
    return this.dependentStore.alignedTransactionGeneratedCollection.collection() ?? [];
  }
}
